<template>
  <div class="containerNoticia" :data-testid="TEST_ID.GESTION_NOTICIAS.FORM_ROOT">
    <el-row>
      <el-col :span="24">
        <div class="title" :data-testid="TEST_ID.GESTION_NOTICIAS.FORM_TITLE">{{ $t('NOTICIAS_nueva_noticia') }}</div>
      </el-col>
    </el-row>

    <el-row>
    <el-col :span="23">

    <el-card>
      <div class="card_body">
         
          <el-row>
            <el-col :span="24">
              <div class="field titleImageRow">
                <div class="titleField">
                  <div class="label">{{ $t('NOTICIAS_titulo') }}</div>
                  <div :data-testid="TEST_ID.GESTION_NOTICIAS.INPUT_TITLE">
                    <el-input
                      class="input titleInput"
                      size="small"
                      :value="noticia.titulo"
                      v-model="noticia.titulo"
                    />
                  </div>
                </div>

                <div class="mainImageField">
                  <FileUpload
                    style="text-align:left !important;"
                    name="noticia"
                    :label-tag="'NOTICIAS_imagen_principal'"
                    :button-icon="'UploadFilled'"
                    :accept="',.jpg,.jpeg,.png,.tiff,.raw'"
                    :limit="1"
                    :files="imagenes"
                    :storeAction="'gestionNoticias/uploadImagen'"
                    :onFileListChange="onImagenesChanged"
                    :temporalId="idTemporal"
                    :inline-file-list="true"
                    :buttonTestId="TEST_ID.GESTION_NOTICIAS.MAIN_IMAGE_UPLOAD"
                  />
                </div>
              </div>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="24">
              <div class="field">
                <div class="label">{{ $t('NOTICIAS_copete') }}</div>
                <div :data-testid="TEST_ID.GESTION_NOTICIAS.TEXTAREA_SUMMARY">
                  <el-input class="textarea"
                  type="textarea"
                  :value="noticia.copete"
                  :rows="2"
                  v-model="noticia.copete" />
                </div>
              </div>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="24">
              <div class="field">
                <div class="label">{{ $t('NOTICIAS_cuerpo') }}</div>
                <div :data-testid="TEST_ID.GESTION_NOTICIAS.TEXTAREA_BODY">
                  <EditorMarkdownNoticias
                    v-model="noticia.cuerpo"
                    :max-length="maxNoticiaBodyLength"
                    :id-carpeta-temporal="idTemporal"
                    @file-blocked="onFileBlocked"
                    @image-uploaded="onEmbeddedImageUploaded"
                  />
                </div>
              </div>
            </el-col>
          </el-row>

        </div>
    </el-card>
    </el-col>
    </el-row>


    <div class="btnContainer">
      <el-button type="primary" 
      @click="save"
      :data-testid="TEST_ID.GESTION_NOTICIAS.BUTTON_SAVE"
      :loading="guardado">{{ $t('GENERAL_saveBtn') }}</el-button>
      <router-link :to="{ name: 'Gestion Noticias', params: { keepFilter: true }}">
        <el-button :data-testid="TEST_ID.GESTION_NOTICIAS.BUTTON_CANCEL">{{ $t('GENERAL_cancelBtn') }}</el-button>
      </router-link>
    </div>
  </div>
</template>

<script>
import FileUpload from '../FileUpload/index'
import EditorMarkdownNoticias from '../Noticias/EditorMarkdownNoticias'
import { mapState } from 'vuex'
import { mostrarMensajeInternacionalizado } from '../MensajeInternacionalizado'
import { showError, showSuccess } from '../Mensaje'
import { MAX_NOTICIA_BODY_LENGTH, hasNoticiaVisibleText } from '../Noticias/noticiaMarkdown'
import TEST_ID from '@/testIds.json'

export default {
  name: 'AltaEdicionNoticia',
  components: { FileUpload, EditorMarkdownNoticias },
  data() {
    return {
      TEST_ID,
      esEdicion: false,
      noticia: {
        id: 0,
        idEstadoNoticia: 1,
        titulo: "",
        copete: "",
        cuerpo: "",
        fechaRegistro: null,
      },
      imagenes: [],
      idTemporal: new Date().getTime().toString(),
      guardado: false,
      loading: false,
      maxNoticiaBodyLength: MAX_NOTICIA_BODY_LENGTH
    }
  },
  computed: {
    ...mapState({
      idUsuario: state => state.sesion.resultadoAutenticacion.IdUsuario,
      nombreCompleto: state => state.sesion.resultadoAutenticacion.NombreCompleto
    }),
  },
  methods: {

    cargarNoticia(noticia) {

      // cargo la solicitud a editar
      this.noticia.titulo = noticia.Titulo;
      this.noticia.copete = noticia.Copete;
      this.noticia.cuerpo = noticia.Cuerpo || '';
      this.noticia.fechaRegistro = noticia.FechaRegistro;
      this.noticia.id = noticia.Id;
      this.noticia.idEstadoNoticia = noticia.EstadoNoticia.Id !== 3 ? noticia.EstadoNoticia.Id : 1
      
      // cargar imagen
      if (noticia.PathImagen) {
        this.imagenes = [{name: noticia.FileNameImagen}];
      }
    },
    onImagenesChanged(name, fileUpload) {
      if (!fileUpload || fileUpload.length === 0) {
        this.imagenes = []
        return
      }

      this.imagenes = [{name: fileUpload[0].name}]

    },
    onEmbeddedImageUploaded() {
      // El backend reconstruye y valida referencias; este hook permite futura telemetría/UI.
    },
    onFileBlocked() {
      showError(this.$t('NOTICIAS_cuerpo_files_not_allowed'))
    },

    buildEmbeddedImageInputs(markdown) {
      const body = String(markdown || '')
      const imageInputs = []
      const existingIds = new Set()
      const temporalTokens = new Set()

      const apiImageRegex = /\/api\/NoticiaImagen\/Get\?idNoticia=\d+&idImagen=(\d+)/gi
      let apiMatch = apiImageRegex.exec(body)
      while (apiMatch) {
        const id = Number(apiMatch[1])
        if (Number.isInteger(id) && id > 0 && !existingIds.has(id)) {
          existingIds.add(id)
          imageInputs.push({ Id: id, TokenTemporal: null })
        }
        apiMatch = apiImageRegex.exec(body)
      }

      const tempImageRegex = /noticia-temporal:\/\/([a-zA-Z0-9_-]+)\/([a-zA-Z0-9_-]+)/gi
      let tempMatch = tempImageRegex.exec(body)
      while (tempMatch) {
        const token = tempMatch[2]
        if (!temporalTokens.has(token)) {
          temporalTokens.add(token)
          imageInputs.push({ Id: null, TokenTemporal: token })
        }
        tempMatch = tempImageRegex.exec(body)
      }

      return imageInputs
    },

   
    save() {
      // indico que se está guardado la noticia
      this.guardado = true
      
      // validaciones
      let valida = true

      if(!this.noticia.titulo) {
        showError(this.$t('NOTICIAS_titulo_missing'))
        valida = false
      }

      if(!this.noticia.copete) {
        showError(this.$t('NOTICIAS_copete_missing'))
        valida = false
      }

      if(!hasNoticiaVisibleText(this.noticia.cuerpo)) {
        showError(this.$t('NOTICIAS_cuerpo_missing'))
        valida = false
      }

      if ((this.noticia.cuerpo || '').length > this.maxNoticiaBodyLength) {
        showError(this.$t('NOTICIAS_cuerpo_too_long'))
        valida = false
      }

      if (this.imagenes.length === 0 || !this.imagenes[0].name) {
        showError(this.$t("ARCHIVOS_archivo_missing"));
        valida = false;
      }

      if(!valida) {
        this.guardado = false
        return
      }

      // armo el payload
      let payload = {
        Id: this.noticia.id,
        IdEstadoNoticia: this.noticia.idEstadoNoticia,
        IdUsuario: this.idUsuario,
        NombreUsuario: this.nombreCompleto,
        Titulo: this.noticia.titulo,
        Copete: this.noticia.copete,
        Cuerpo: this.noticia.cuerpo,
        PathImagen: this.imagenes.length > 0 ? this.imagenes[0].name : '',
        IdCarpetaTemporal: this.idTemporal, 
        FechaRegistro: this.noticia.fechaRegistro,
        Imagenes: this.buildEmbeddedImageInputs(this.noticia.cuerpo)
      }
      // persisto la noticia      
      this.$store.dispatch('gestionNoticias/saveNoticia', payload)
      .then(codigoResultado => 
      {
        if(codigoResultado > 0)
        {
          showSuccess(this.$t('NOTICIAS_success'));
          if(this.esEdicion)
            this.$router.push({ name: 'Gestion Noticias', params: {keepFilter: true}});
          else
            this.$router.push({ name: 'Gestion Noticias', params: {
              idNuevaNoticia: codigoResultado
              }})
        }
        else
          mostrarMensajeInternacionalizado(codigoResultado)
      })
      .finally(() => this.guardado = false);
    },
  },

    mounted() {

    if (this.$route.params.id) {
      // indico que es una edición de Noticia
      this.esEdicion = true;

      // busco la Noticia a editar
      this.$store
      
        .dispatch("gestionNoticias/getNoticia", {
          id: this.$route.params.id,
        })
        .then(data => {
          this.cargarNoticia(data);
        });

    }
  }
  
};
</script>

<style scoped>
.containerNoticia {
  display: block;
  padding: 0 30px;
  max-width: 1320px;
  width: 100%;
  margin: 0 auto;
  box-sizing: border-box;
}
.card_body {
  text-align: left;
}
.title {
  font-size: 22px;
  font-weight: bold;
  line-height: 26px;
  margin: 0 0 20px;
  padding: 0 0 7px;
}

.field {
  padding: 0 8px;
}

.titleImageRow {
  display: flex;
  align-items: flex-end;
  gap: 8px;
  flex-wrap: nowrap;
}

.titleField {
  flex: 0 0 400px;
  min-width: 0;
}

.titleField :deep(.titleInput) {
  display: flex;
  width: 100%;
}

.mainImageField {
  flex: 0 0 auto;
  min-width: 0;
  display: flex;
  align-items: flex-end;
}

.label {
  font-size: 14px;
  text-align: left;
  margin: 15px 0 4px;

}

.mainImageField :deep(.el-upload) {
  display: inline-flex;
  align-items: flex-end;
  white-space: nowrap;
}

.mainImageField :deep(.el-upload__tip) {
  flex: 0 1 auto;
  max-width: 280px;
  overflow: visible;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.input {
  box-sizing: border-box;
  display: inline-block;
  outline: 0;
}
.textarea {
  border-radius: 4px;
  min-height: 90px;
}
.imagen {
  vertical-align: top;
}
.btnContainer {
  margin-top: 30px;
}

  @media(max-width: 600px) {

    .containerNoticia {
     padding: 2px 5px;
    }

    .titleImageRow {
      flex-direction: column;
      align-items: stretch;
      gap: 8px;
    }

    .titleField {
      flex-basis: auto;
      width: 100%;
    }

    .mainImageField {
      width: 100%;
    }
  }
</style>